import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Footer from '../MainFrame/Footer/Footer';
import useAuth from '../../../hooks/authentication/useAuth';
import ProfileHeaderWrapper from '../Header/HeaderLayout';

const ProfileFrame: React.FC<{ children?: React.ReactNode }> = () => {
    const auth = useAuth();

    return (
        <>
            {!auth.isLoggedIn && <Navigate to={'/login'} replace />}
            {auth.isLoggedIn && (
                <>
                    <ProfileHeaderWrapper />
                    <Outlet />
                    <Footer />
                </>
            )}
        </>
    );
};

export default ProfileFrame;
